"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colors = void 0;
exports.colors = {
    greyBase: "#1e2120",
    greyLighten40: "#4d4d4d",
    greyLighten70: "#b5b5b5",
    whiteBase: "#ffffff",
    greenBase: "#1eb8bd",
    greenLighten80: "#d3f2ef",
    yellowBase: "#ecab30",
    yellowLighten80: "#fff4e0",
    pinkBase: "#ec305f",
    pinkLighten80: "#ffdfe7",
    blueBase: "#3d73dd",
    blueLighten80: "#edf3ff",
    silverBase: "#eaeaea",
    silverLighten40: "#fafafa",
    silverLigthen50: "#C2C2C2",
    silverLighten60: "#c4c4c4",
    silverLighten70: "#f6f6f6"
};
//# sourceMappingURL=colors.js.map